import { atomWithStorage } from 'jotai/utils';

// カラーテーマのプリセット名。識別子・表示名は gray / white / black / red の4種。
// gray は無彩色の既定テーマ。white/black/red の配色トンマナ（サイドバー基調色＋アクセント）は
// Slack をインスパイア元とするが、UI 文言・識別子に "slack" は含めない。
// 実体は src/styles/theme.ts の buildTheme で定義する。
export type ThemeName = 'gray' | 'white' | 'black' | 'red';

// テーマはブラウザ単位で共通（powertrainAtom と同方針）。localStorage 永続・リロードでも保持。
export const themeAtom = atomWithStorage<ThemeName>(
    'themeName',
    'gray',
    undefined,
    { getOnInit: true },
);
